import classNames from "classnames";
import React from "react";

export const LineClamp = ({
  text,
  lines,
  className,
  style,
  breakAll,
}: {
  text: React.ReactNode;
  className?: string;
  lines: number;
  style?: React.CSSProperties;
  breakAll?: boolean;
}) => {
  return (
    <div
      className={classNames(
        "lux-line-clamp",
        breakAll ? "break-all" : "break-words",
        className,
      )}
      style={style}
    >
      {text}

      <style jsx>{`
        // TODO: consider moving this to style prop
        .lux-line-clamp {
          -webkit-line-clamp: ${lines};
        }
      `}</style>
    </div>
  );
};
